import { Badge } from '../../../components/ui/Badge/Badge';
import type { DwtDueState } from '../../../api/dwt';
import { DWT_DUE_LABEL, DWT_DUE_VARIANT, DWT_STATUS_HELP, DWT_STATUS_VARIANT, dwtStatusLabel } from '../dwtLabels';

export function DwtStatusBadge({ status }: { status: string | null | undefined }): JSX.Element {
  const key = status ?? 'none';
  return (
    <span title={DWT_STATUS_HELP[key] ?? ''}>
      <Badge variant={DWT_STATUS_VARIANT[key] ?? 'muted'}>{dwtStatusLabel(status)}</Badge>
    </span>
  );
}

export function DwtDueBadge({ state }: { state: DwtDueState | null | undefined }): JSX.Element | null {
  if (!state) return null;
  return <Badge variant={DWT_DUE_VARIANT[state]}>{DWT_DUE_LABEL[state]}</Badge>;
}
